// Protección básica: sin clic derecho, sin arrastrar fotos, sin "guardar imagen" al mantener presionado,
// y sin los atajos de teclado que abren el inspector o el código fuente (F12, Ctrl+Shift+I/J/C, Ctrl+U, Ctrl+S).
// Es un freno para la copia casual: quien sabe puede abrir el inspector desde el menú del navegador o hacer una captura.
// La seguridad real (pagos, cuentas, datos) la da Shopify en el servidor; aquí no hay nada secreto que esconder.
(() => {
  // En el editor de temas de Shopify (Personalizar) no se bloquea nada, para poder editar con normalidad.
  if (window.Shopify && window.Shopify.designMode) return;

  const editable = (el) => el && el.closest && el.closest('input, textarea, [contenteditable="true"]');

  document.addEventListener('contextmenu', (e) => {
    if (!editable(e.target)) e.preventDefault();
  });
  document.addEventListener('dragstart', (e) => {
    if (e.target.closest && e.target.closest('img, video, picture, a')) e.preventDefault();
  });
  document.addEventListener('keydown', (e) => {
    // e.code ("KeyI") porque en Mac la tecla Option cambia e.key
    const k = (e.code && e.code.startsWith('Key') ? e.code.slice(3) : e.key || '').toLowerCase();
    const mod = e.ctrlKey || e.metaKey;
    const bloquear =
      k === 'f12' ||
      (mod && e.shiftKey && ['i', 'j', 'c'].includes(k)) ||
      (e.metaKey && e.altKey && ['i', 'j', 'c', 'u'].includes(k)) ||
      (mod && !e.shiftKey && ['u', 's'].includes(k));
    if (bloquear) e.preventDefault();
  });

  const style = document.createElement('style');
  style.textContent = 'img, video { -webkit-user-drag: none; user-drag: none; -webkit-touch-callout: none; user-select: none; }';
  document.head.appendChild(style);
})();
